import React, { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Plus, X, Trash2 } from "lucide-react";

const NEW = "__new__";

export default function CatalogField({ label, value, options = [], onChange, onDelete, testid, placeholder, disabled, allowAdd = true }) {
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState("");

  const startNew = () => { setAdding(true); setDraft(""); };
  const confirmNew = () => {
    const v = draft.trim();
    if (v) onChange(v);
    setAdding(false);
    setDraft("");
  };

  // If current value is not in options (e.g. legacy free text), include it so it displays.
  const opts = value && !options.includes(value) ? [value, ...options] : options;

  const slug = (o) => String(o).replace(/\s+/g, "-").toLowerCase();

  return (
    <div>
      <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</Label>
      {adding ? (
        <div className="mt-1.5 flex items-center gap-1">
          <Input
            data-testid={`${testid}-new-input`}
            autoFocus
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); confirmNew(); } }}
            className="rounded-sm h-9"
            placeholder={placeholder}
          />
          <button type="button" onClick={confirmNew} className="h-9 w-9 flex items-center justify-center bg-slate-900 text-white rounded-sm hover:bg-slate-800 transition-colors duration-200">
            <Plus className="h-4 w-4" />
          </button>
          <button type="button" onClick={() => setAdding(false)} className="h-9 w-9 flex items-center justify-center border border-slate-300 rounded-sm hover:bg-slate-50 transition-colors duration-200">
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <Select
          value={value || ""}
          disabled={disabled}
          onValueChange={(v) => (v === NEW ? startNew() : onChange(v))}
        >
          <SelectTrigger data-testid={testid} className="mt-1.5 rounded-sm">
            <SelectValue placeholder="Seleccionar..." />
          </SelectTrigger>
          <SelectContent>
            {opts.map((o) => (
              <div key={o} className="relative flex items-center group">
                <SelectItem value={o} className={onDelete ? "flex-1 pr-8" : "flex-1"}>{o}</SelectItem>
                {onDelete && (
                  <button
                    type="button"
                    data-testid={`${testid}-del-${slug(o)}`}
                    title="Eliminar de la lista"
                    className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1 text-slate-300 hover:text-red-600 opacity-60 hover:opacity-100"
                    onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); onDelete(o); }}
                  >
                    <Trash2 className="h-3.5 w-3.5" />
                  </button>
                )}
              </div>
            ))}
            {allowAdd && <SelectItem value={NEW} className="text-slate-900 font-semibold">＋ Agregar nuevo…</SelectItem>}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
